import { Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./content/vendor/bootstrap/css/bootstrap.min.css',
    // './content/vendor/font-awesome/css/font-awesome.min.css'
  ]
})
export class AppComponent {
  title = 'Photo-Me';

  constructor(private translate: TranslateService) {
    translate.setDefaultLang('ja');
  }
}
